export interface ILineItemPropertyAPI {
  lineitemproperty_id: number;
  lineitem_id: number;
  key: string;
  value: string;
  is_required: boolean;
  organization_id: number;
  name: string;
}

export default class LineItemProperty {
  id: number;

  lineItemID: number;

  key: string;

  value: string;

  isRequired: boolean;

  organizationID: number;

  name: string;

  constructor(
    id = -1,
    lineItemID: number,
    key: string,
    value: string,
    isRequired: boolean = false,
    organizationID: number = null,
    name: string = null,
  ) {
    this.id = id;
    this.lineItemID = lineItemID;
    this.key = key;
    this.value = value;
    this.isRequired = isRequired;
    this.organizationID = organizationID;
    this.name = name;
  }

  static fromApi(apiObject: ILineItemPropertyAPI): LineItemProperty {
    return new LineItemProperty(
      apiObject.lineitemproperty_id,
      apiObject.lineitem_id,
      apiObject.key,
      apiObject.value,
      apiObject.is_required,
      apiObject.organization_id,
      apiObject.name,
    );
  }

  toApi(): ILineItemPropertyAPI {
    return {
      lineitemproperty_id: this.id >= 0 ? this.id : undefined,
      key: this.key,
      value: this.value,
      is_required: this.isRequired,
      organization_id: this.organizationID,
      name: this.name,
      lineitem_id: this.lineItemID != null ? this.lineItemID : undefined,
    };
  }

  toString() {
    return (this.name || this.key) + ': ' + this.value;
  }
}
